import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

export const useFloorPlanner = create(
  subscribeWithSelector((set) => ({
    eventSettings: {
      booth_dimension_unit: "feet",
      currency: "INR",
      booth_color_available: "#ffffff",
      booth_color_assigned: "#ff69b4",
      booth_color_reserved: "#d3d3d3",
      booth_label_type: "company_name",
    },
    
    setEventSettings: (updater) =>
      set((state) => ({
        eventSettings: typeof updater === "function" ? updater(state.eventSettings) : { ...state.eventSettings, ...updater },
      })),
  }))
);
